import { Action } from '@ngrx/store';

export const ACTIVAR_EDIT = '[EDITOR] Act Oper';
export const CANCELAR_EDIT = '[EDITOR] Can Oper';


export class ActivarEditAction implements Action {
  readonly type = ACTIVAR_EDIT;
  constructor( public Operacion: string, public Capa: string) {}
}

export class CancelarEditAction implements Action {
  readonly type = CANCELAR_EDIT;
  constructor ( public IdCapa: string , public IdCambioCapa:string, public OperacionCambio:string) {}
}

export type EditActions =
    | ActivarEditAction
    | CancelarEditAction;